import { render, staticRenderFns } from "./ChecklistProposta.vue?vue&type=template&id=1b1a0760&"
import script from "./ChecklistProposta.vue?vue&type=script&lang=js&"
export * from "./ChecklistProposta.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistProposta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports